
import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { GreyhoundAndTrainerDetails } from 'src/domains/sportsbook/webview/components/raceSummary/templates/runnerInfo/GreyhoundAndTrainerDetails';
import { Trap } from 'src/domains/sportsbook/webview/components/trap/Trap';
import { withConfig } from 'src/withConfig';

interface RaceResultsRowCaptionPropsType {
    variant: DefaultComponentVariantType | null;
}

const setRaceResultsRowCaption = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.medium};
        `;
    }
    return css`
        border-style: solid;
        border-color: ${theme.star.raceSummary.borderColor};
        border-width: 0 0 1px 0;
    `;
};

export const RaceResultsRowCaption = withConfig(theme => styled('div', { label: 'RaceResultsRowCaption' })<RaceResultsRowCaptionPropsType>`
    ${({ variant }): SerializedStyles => setRaceResultsRowCaption(variant, theme)}
    color: ${theme.star.raceSummary.txtColorTertiary};
    display: flex;
    flex-flow: row nowrap;
    font-size: ${theme.star.fontSize.xSmall};
    height: 48px;
    justify-content: space-between;
    line-height: 1.4;
    @media ${theme.star.mediaQuery.tablet} {
        border-width: 0 0 1px 1px;
        height: 56px;
    }
`);

export const ResultCell = withConfig(theme => styled('span', { label: 'ResultCell' })`
    align-items: center;
    border-right: 1px solid ${theme.star.raceSummary.borderColor};
    color: ${theme.star.raceCard.results.txtColorSecondary};
    display: flex;
    flex-flow: column nowrap;
    flex: 0 0 64px;
    font-size: ${theme.star.fontSize.xMedium};
    font-weight: ${theme.star.fontWeight.bold};
    justify-content: center;
    text-align: center;
`);

export const ResultSelectionCell = withConfig(theme => styled('span', { label: 'ResultSelectionCell' })`
    align-items: center;
    border-left: 1px solid ${theme.star.raceSummary.borderColor};
    color: inherit;
    display: flex;
    flex: 0 0 48px;
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
    justify-content: center;
    margin-right: 0;
    padding: 1px 4px;
    text-align: center;
    @media ${theme.star.mediaQuery.tablet} {
        flex: 0 0 64px;
        margin-left: -1px;
    }
`);

export const CellRunner = styled('div', { label: 'CellRunner' })`
    align-items: center;
    align-self: stretch;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 1 auto;
    gap: 12px;
    justify-content: start;
    min-width: 120px;
    overflow: hidden;
    padding: 8px 12px;
`;

export const RaceSummaryTrap = styled(Trap, { label: 'RaceSummaryTrap' })`
    flex: 0 0 32px;
    padding: 4px;
    width: 32px;
`;

export const GreyhoundAndTrainerDetailsBox = withConfig(theme => styled(GreyhoundAndTrainerDetails, { label: 'GreyhoundAndTrainerDetailsBox' })`
    align-items: flex-start;
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    font-size: ${theme.star.fontSize.xSmall};
    justify-content: center;
    overflow: hidden;
    width: 100%;
`);
